<h2 mat-dialog-title class="save-dialog-title">Save Confirmation</h2>

<mat-dialog-content class="save-dialog-content" *ngIf="!isSaveClicked">
  <p class="save-dialog-message">
    Please ensure all documents and fields are completed accurately prior to
    submission.
  </p>
  <p class="save-dialog-subtitle">The following files will be saved:</p>
  <ul class="save-dialog-doc-list">
    <li *ngFor="let doc of docName">{{ doc }}</li>
  </ul>
</mat-dialog-content>

<mat-dialog-content class="save-dialog-content save-dialog-content--success" *ngIf="isSaveClicked">
  <p class="save-dialog-success">Your documents have been updated!</p>
</mat-dialog-content>

<mat-dialog-actions align="end" class="save-dialog-actions">
  <button
    mat-stroked-button
    class="seneca-button seneca-stroke-button"
    mat-dialog-close
    *ngIf="!isSaveClicked"
  >
    Cancel
  </button>
  <button
    mat-flat-button
    class="seneca-button save-dialog-primary"
    color="primary"
    (click)="onSaveConfirmed()"
    *ngIf="!isSaveClicked"
    cdkFocusInitial
  >
    Save
  </button>
  <button
    mat-flat-button
    class="seneca-button save-dialog-primary"
    color="primary"
    mat-dialog-close
    *ngIf="isSaveClicked"
    cdkFocusInitial
  >
    Done
  </button>
</mat-dialog-actions>
